export default __webpack_public_path__ + "static/media/16-KiwiSummer.458b9f08.jpeg";